import React from 'react'
import { shallow } from 'enzyme'

import { BusinessQuestions } from '../../components/BusinessQuestions'

describe('BusinessQuestions', () => {
  let wrapper, props, instance

  beforeAll(() => {
    props = {
      getQuestions: () => {
        return {
          questions_experience: [1]
        }
      },
      type: 'Guarantor',
      data: {
        loading: false,
        error: false,
        business: {
          rid: 2,
          borrowerType: 'oc'
        }
      },
      isPaycheckProtection: true
    }
    wrapper = shallow(<BusinessQuestions {...props} />)
    instance = wrapper.instance()
  })

  describe("#render", () => {
    it("renders", () => {
      expect(wrapper).toBeTruthy()
    })
  })

  describe("#categories", () => {
    describe("when not ppp", () => {
      it("should return array", () => {
        const { categories } = instance

        expect(categories.length).toBe(11)
      })
    })

    describe("#when EpcBusiness", () => {
      it("should return array", () => {
        wrapper.setProps({ type: 'EpcBusiness' })
        const { categories } = instance

        expect(categories.length).toBe(1)
      })
    })

    describe("#when EpcBusiness", () => {
      it("should return array", () => {
        wrapper.setProps({ type: 'Business', isPaycheckProtection: false })
        const { categories } = instance

        expect(categories.length).toBe(11)
      })
    })
  })

  describe("#getQuestionsByCategory", () => {
    it("returns array", () => {
      const arr = instance.getQuestionsByCategory('questions_experience')

      expect(arr.length).toBe(1)
    })
  })
})
